import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransactionList } from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  CLIENT,
  TRANSACTION_CREDITED,
  TRANSACTION_DEBITED,
  TRANSACTION_FAILED,
  TRANSACTION_PENDING,
  TRANSACTION_REFUND,
} from "../../../../utility/constants/valueConstants";
import { formatBalance } from "../../../../utility/moneyFormatter";
import {
  PayoutTransactionHeaders,
  TransactionHeaders,
} from "../../../../utility/TableHeaders";
import CustomModal from "../../../components/main_comps/custom_modal";
import { CustomViewModal } from "../../../components/main_comps/custom_modal/CustomViewModal";
import CustomTable from "../../../components/main_comps/custom_table";

const PayoutTransaction = ({ selectedService }) => {
  const dispatch = useDispatch();
  const transaction = useSelector(
    (state) => state.listingSlice.payoutTransactionList
  );
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const [currentPage, setCurrentPage] = useState(0);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [viewMoreData, setViewMoreData] = useState({});
  const [dataForModal, setDataForModal] = useState({});
  const [clientDetails, setClientDetials] = useState({});

  const filters = useSelector((state) => state.globalFiltersSlice);
  const getClientProgram = () => {
    let payout = clientSecret.filter((obj) => obj.serviceType === "payout");
    if (payout.length > 0) {
      setClientDetials(payout[0]);
    }
  };
  const role = secureStorage.getItem(SS_ROLE);

  useEffect(() => {
    let data1 = {
      "Reseller Name": viewMoreData?.reseller_name ?? "N/A",
    };
    let data = {
      "Date & Time:": moment(viewMoreData?.created_at).format(
        "DD/MM/YYYY HH:mm A"
      ),
      "Client Name": viewMoreData?.client_name ?? "N/A",

      "Bank Utr:": viewMoreData?.utr ? viewMoreData?.utr : "N/A",
      "Service type:": viewMoreData?.service_type
        ? viewMoreData?.service_type
        : "N/A",
      "Transfer Mode": viewMoreData?.transferMode
        ? viewMoreData?.transferMode
        : "N/A",

      "Actual Amount":
        "Rs " + formatBalance(Number(viewMoreData?.actual_amount)),
      // Commission:
      //   viewMoreData["status"] === TRANSACTION_CREDITED ||
      //   viewMoreData["status"] === TRANSACTION_DEBITED
      //     ? "Rs " + formatBalance(Number(viewMoreData?.commissionAmount))
      //     : "Rs 0",
      // "Commission Gst":
      //   viewMoreData["status"] === TRANSACTION_CREDITED ||
      //   viewMoreData["status"] === TRANSACTION_DEBITED
      //     ? "Rs " + formatBalance(Number(viewMoreData?.commissionGst))
      //     : "Rs 0",

      "Final Amount":
        viewMoreData["status"] === "TRANSFER_SUCCESS" ||
        viewMoreData["status"] === "CREDIT_CONFIRMATION" ||
        viewMoreData["status"] === "TRANSFER_ACKNOWLEDGED" ||
        viewMoreData["status"] === "SUCCESS"
          ? "Rs " + formatBalance(Number(viewMoreData?.final_amount))
          : "Rs " + formatBalance(Number(viewMoreData?.actual_amount)),
      "Transaction Id": viewMoreData?.referenceId
        ? viewMoreData?.referenceId ?? "N/A"
        : viewMoreData?.transferId ?? "N/A",

      Status:
        viewMoreData["status"] === "TRANSFER_SUCCESS" ||
        viewMoreData["status"] === "CREDIT_CONFIRMATION" ||
        viewMoreData["status"] === "TRANSFER_ACKNOWLEDGED" ||
        viewMoreData["status"] === "SUCCESS"
          ? "Success"
          : viewMoreData?.status === TRANSACTION_PENDING ||
            viewMoreData?.status === "RECEIVED" ||
            viewMoreData?.status === "INPROGRESS"
          ? "Initiated"
          : "Failed",

      "Benficiary name": viewMoreData?.beneDetails?.name ?? "N/A",
      "Benficiary Acc no": viewMoreData?.beneDetails?.bankAccount ?? "N/A",
      "Benficiary Acc Type": viewMoreData?.beneDetails?.accountType ?? "N/A",
      "Benficiary IFSC code": viewMoreData?.beneDetails?.ifsc ?? "N/A",
      "Benficiary Bank name": viewMoreData?.beneDetails?.name ?? "N/A",
      Vpa: viewMoreData?.beneDetails?.vpa ?? "N/A",
      "Benficiary email Id": viewMoreData?.beneDetails?.email ?? "N/A",
      "Benficiary Mobile No": viewMoreData?.beneDetails?.phone ?? "N/A",
      "Corp Acc No": viewMoreData?.beneDetails?.corp ?? "N/A",
      "Modified Date": moment(viewMoreData?.modified_at).format(
        "DD/MM/YYYY HH:mm A"
      ),
    };

    if (role === CLIENT) {
      setDataForModal(data);
    } else {
      setDataForModal({ ...data, ...data1 });
    }
  }, [viewMoreData]);

  const setHeaders = (data, role, acl) => {
    let arr = [];

    data &&
      data?.map((val, i) => {
        if (val?.roles || val?.acl) {
          if (val?.roles?.includes(role) || acl?.includes(val?.acl))
            arr.push({
              title: val?.title,
              key: val?.key,
            });
        } else {
          arr.push({
            title: val?.title,
            key: val?.key,
          });
        }
      });
    return arr;
  };
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 15);
  const defaultDateRange = `${("0" + startDate.getDate()).slice(-2)}/${(
    "0" +
    (startDate.getMonth() + 1)
  ).slice(-2)}/${startDate.getFullYear()}-${("0" + endDate.getDate()).slice(
    -2
  )}/${("0" + (endDate.getMonth() + 1)).slice(-2)}/${endDate.getFullYear()}`;

  useEffect(() => {
    if (selectedService || clientDetails?.serviceProviderName) {
      dispatch(
        fetchTransactionList({
          dateRange:
            filters?.fromDate && filters?.toDate
              ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                "-" +
                moment(filters?.toDate).format("DD/MM/YYYY")
              : defaultDateRange,
          page: 0,
          size: 10,
          resellerId: filters?.resellerId?.value,
          clientId: filters?.clientId?.value,
          status: filters?.status ? filters?.status?.value : "",
          serviceType: "payout",
          rootReferenceId: "",
          custRefNo: filters?.custRefNo ?? "",
          transactionId: filters?.transactionId ?? "",
          serviceProviderName:
            role === CLIENT
              ? clientDetails?.serviceProviderName
              : selectedService,
        })
      );
    }
  }, [clientDetails, selectedService]);

  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, []);

  return (
    <div style={{ padding: "0px 10px", overflow: "hidden" }}>
      <CustomTable
        data={transaction?.transactions}
        currentPage={transaction?.currentPageNo - 1}
        headers={setHeaders(PayoutTransactionHeaders, role)}
        totalElements={transaction?.totalRecords}
        totalPages={transaction?.totalPages}
        handlePaginate={(page) => {
          setCurrentPage(page);
          dispatch(
            fetchTransactionList({
              dateRange:
                filters?.fromDate && filters?.toDate
                  ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(filters?.toDate).format("DD/MM/YYYY")
                  : "",
              page: page + 1,
              size: 10,
              resellerId: filters?.resellerId?.value,
              clientId: filters?.clientId?.value,
              status: filters?.status ? filters?.status.value : "",
              serviceType: "payout",
              custRefNo: filters?.custRefNo ?? "",
              transactionId: filters?.transactionId ?? "",
              serviceProviderName:
                role === CLIENT
                  ? clientDetails?.serviceProviderName
                  : selectedService,
            })
          );
        }}
        onViewMore={(row) => {
          setViewMoreModal(true);
          setViewMoreData(row);
        }}
        emptyDataMessage="No transaction found."
      />

      {viewMoreModal && (
        <CustomModal
          open={viewMoreModal}
          onClose={() => {
            setViewMoreModal(false);
            // setDataForModal({});
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "100%",
            borderRadius: "20px 0px 0px 20px",
          }}
          viewMoreStyle={{
            justifyContent: "flex-end",
          }}
          isHeaderRequired={false}
        >
          <CustomViewModal
            data={dataForModal}
            closeModal={() => {
              setViewMoreModal(false);
              // setDataForModal({});
            }}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default PayoutTransaction;
